import * as React from 'react';
import { LocationTrackingSchedule } from 'cb-model';
import {
  IsAllowed,
  PageTitle,
  PaginatorAndListSettings,
  Search,
  Section,
  useCacheQuery,
  useQueryOptionsFromSearchParams,
} from 'gossamer-front-end';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useInstitutionFilter } from '../institution/useInstitutionFilter';

/**
 * Location Tracking Schedule Search Page
 *
 * Search and list all location tracking schedules for the user's institution
 */
export const LocationTrackingScheduleSearch = (): React.JSX.Element => {
  const initialQueryOptions = useInstitutionFilter({ where: { and: LocationTrackingSchedule.defaultFilters } });
  const [queryOptions, setQueryOptions] = useQueryOptionsFromSearchParams(
    LocationTrackingSchedule,
    initialQueryOptions,
  );
  const gCacheQueryItem = useCacheQuery(LocationTrackingSchedule, queryOptions);

  return (
    <>
      <PageTitle verb="Search" entity={LocationTrackingSchedule} />
      <Section>
        <IsAllowed entity={LocationTrackingSchedule} action="create">
          <Link to="/admin/location-tracking-schedule/create">
            <Button size="sm" variant="primary">
              Create a new Location Tracking Schedule
            </Button>
          </Link>
          <div className="mb20px" />
        </IsAllowed>
        <PaginatorAndListSettings
          entity={LocationTrackingSchedule}
          gCacheQuery={gCacheQueryItem}
          queryOptions={queryOptions}
          render={Search}
          setQueryOptions={setQueryOptions}
        />
      </Section>
    </>
  );
};
